import { app } from '../../../app';
import { Controller } from '../login/login.controller';

app.component('loginModal', {
    controller: Controller,
    templateUrl: require('./login.modal.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/login-modal/login-modal.component.js